import React, { useCallback } from "react";
import { socket } from "../../../../lib/socketio";
import { Grid, Button, Segment } from "semantic-ui-react";
import OperationMode from "../../../Macros/OperationMode";
import ConfirmMacro from "../../../Macros/ConfirmMacro";
import EventLog from "../EventLog";
import { GroupTemplate } from "../../../Definitions/cl";
import Footer from "../../Footer";
import _ from "lodash";
import PPOperationMacro from "../../../Macros/PPOperationMacro"; // update 2403xx by sumin, when click PP Start, PSM1 to PSM5 start
import KWDispatch from "../../../Macros/KWDispatch";
import { showSidebarMenu, setUser } from "../../../../actions/navActions";
import {
  setHasHeaderReceived,
  setUserArray,
  setCurrentPLC,
} from "../../../../actions/headerActions";
import { connect } from "react-redux";
import ActiveEvents from "../ActiveEvents";
import { useHistory, useLocation } from "react-router-dom";
// [UPDATE] PP Operation event log, 250703
import ActiveEventsTable from "../ActiveEventsTable";

import { useSelector, useDispatch } from "react-redux";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { OPERATIONS_WRITE, isAuthorized } from "../../../../lib/authorization";

// update 230711
// TODO 나중에 PPOperationMacro -> PPOpeationMacro로 변경 필요함

const PPOperations_MAIN = ({ hasHeaderReceived }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [overrideVisible, setOverrideVisible] = React.useState({
    visible: true,
  });
  const [isOperationModeCopied, setIsOperationModeCopied] =
    React.useState(false);
  //datalayer 연결여부 확인
  const [eachDataLayerReady, setEachDataLayerReady] = React.useState();
  // [UPDATE] PP Operation event log, 250703
  const [tableData, setTableData] = React.useState([]);

  let history = useHistory();

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  // [UPDATE] PP Operation event log, 250703
  React.useEffect(() => {
    fetchEvents();
    return () => {
      socket.removeAllListeners();
    };
  }, []);

  React.useEffect(() => {
    if (tags.length === 0 && hasHeaderReceived) {
      socket.emit("get tag names", [
        { display_id: 1 },
        { display_id: 7 },
        { display_id: 8 },
        { display_id: 9 },
      ]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags, hasHeaderReceived]);

  // [UPDATE] PP Operation event log, 250703
  const fetchEvents = () => {
    var eventdata = { buttonClickType: "Get Active Events" };
    socket.emit("button click", eventdata);
    socket.on("receive active events", (data) => {
      setTableData(data.result);
    });
  };

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 1 ? [t] : []));

  const GenTags = tags.flatMap((t) => (t.display_id === 7 ? [t] : []));

  const PPTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const ShowSD = (value) => {
    if (value === 1) {
      return 1;
    } else {
      return 0;
    }
  };

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });
      socket.emit("get data layer ready", ids);
      socket.on("receive data layer ready2", (value) => {
        console.log("receive");
        setEachDataLayerReady(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data, eachDataLayerReady]);

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 1000);
    return () => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const setOverrideVisiblity = () => {
    setOverrideVisible({
      ...overrideVisible,
      ["visible"]: !overrideVisible.visible,
    });
  };

  const parentcallback = useCallback((flag) => {
    if (flag === true) {
      setIsOperationModeCopied(false);
    }
  }, []);

  // update SOFC by sumin, 240223 : temporary condition about Plant Start (PSM1State ~ PSM5State range)
  const PState = data[29129];
  const PSM1PState = data[6717];
  const PSM2PState = data[10631];
  const PSM3PState = data[14545];
  const PSM4PState = data[18459];
  const PSM5PState = data[22373];

  const PSM1PPStart = data[6776];
  const PSM2PPStart = data[10690];
  const PSM3PPStart = data[14604];
  const PSM4PPStart = data[18518];
  const PSM5PPStart = data[22432];

  const PSM1PPSD = data[9574];
  const PSM2PPSD = data[13488];
  const PSM3PPSD = data[17402];
  const PSM4PPSD = data[21316];
  const PSM5PPSD = data[25230];

  // const RState = data[6239];
  const IState = data[29132];
  const NState = data[29130];
  const WState = data[29136];
  const CState = data[29131];

  const OperIn_Idle = data[5555];
  const OperIn_GrInd = data[5557];
  const OperIn_GrConn = data[5556];
  const PPSD = data[5549];
  // const ExternalPower = data[9999];  // no 9999s in Sumin's tag. This will conflict with cloud system
  const PPStart = data[9006];
  // const N205Hung = data[9999];
  // const HPEn = data[9999];
  // const HTR302SDLatch = data[9999];
  // const LPGSelect = data[9999];

  const SDColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup === "SD TYPE" ? (
          <Grid.Column>
            {r.tag_display_name === "NORMALSD" ? (
              <Grid.Column
                width="4"
                style={{
                  opacity: ShowSD(data[r.id]) ? "1" : "0.2",
                  overflowWrap: "break-word",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "yellow",
                }}
              >
                {r.tag_display_name}{" "}
              </Grid.Column>
            ) : (
              <Grid.Column
                width="4"
                style={{
                  opacity: ShowSD(data[r.id]) ? "1" : "0.2",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "yellow",
                }}
              >
                {r.tag_display_name}{" "}
              </Grid.Column>
            )}
          </Grid.Column>
        ) : (
          <></>
        ),
      ),
    ),
  );

  // TODO - SOFC : FR P100 Sensor Check : main에서 어떻게 표기해야하는지 확인 필요함
  const GetILTag = (id, value) => {
    // const HECond = data[8292];
    const PPStart = data[9006];
    // ! TODO : TE110FT, TE120FT, TE300FT, TE090FT, IDC1, IDC2, IDC3 조건 미적용
    if (PPStart === 1) {
      //   if(value === 1 && id === 13316) return 'CV011_STATUS = 1 ';
      //   else if ((value < 0.0 || value > 3.0) && id === 10025 ) return '0.0 < FT012 < 3.0';
      //   else if ((value < 0.0 || value > 10.0) && id === 10028) return '0.0 < PDT110 < 10.0';
      //   else if ((value < -2.0 || value > 2.0) && id === 10034) return '-2.0 < PDT390 < 2.0';
      //   else if ((value < -30 || value > 250) && id === 10106) return '-30 < TE380 < 250';
      //   else if ((value < -30 || value > 250) && id === 10109) return '-30 < TE385 < 250';
      //   else if ((value === -999) && id === 13638) return 'TE110FT = -999';
      //   else if ((value === -999) && id === 13620) return 'TE120FT = -999';
      //   else if ((value === -999) && id === 13626) return 'TE300FT = -999';
      //   else if ((value === -999) && id === 13636) return 'TE090FT = -999';
      // IDC1 조건 ?
    }
  };

  const ILColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup ===
        "P100 UNSATISFIED INTERLOCKS" ? (
          <Grid.Column
            key={r.id}
            width="4"
            style={{ textAlign: "center", marginBottom: "10px" }}
          >
            {GetILTag(r.id, data[r.id])}{" "}
          </Grid.Column>
        ) : (
          <></>
        ),
      ),
    ),
  );

  const MDColumn = _.times(1, (i) =>
    Object.keys(PPTags[0]).map((i) =>
      PPTags[0][i].map((r) =>
        PPTags[0][i][0].tag_display_subgroup === "MAJOR DATA" ? (
          <>
            <Grid.Column>{r.tag_display_name} </Grid.Column>
            <Grid.Column style={{ color: "yellow" }}>
              {data[r.id]} {r.unit}{" "}
            </Grid.Column>
          </>
        ) : (
          <></>
        ),
      ),
    ),
  );

  // TODO : FR - HMI, PowerPlant Operations 확인
  const PPStatus = (PS, RS, IS, OpIdle, OpGrInd, OpGrCon) => {
    // (PState,RState,IState, OperIn_Idle, OperIn_GrInd, OperIn_GrConn)
    // if((PS === 150 && IS === 26) || (PS === 160)) {
    //     return 'IDLE';
    // }
    if ((PS >= 5 && PS <= 100) || (PS >= 600 && PS <= 700)) {
      return "SHUTDOWN";
    } else if (PS >= 110 && PS <= 310 && RS !== 245 && OpIdle === 1) {
      return "STARTING - IDLE";
    } else if (PS >= 110 && PS <= 310 && RS !== 245 && OpGrInd === 1) {
      return "STARTING - GI LOAD";
    } else if (PS >= 110 && PS <= 310 && RS !== 245) {
      return "STARTING - GC LOAD";
    } else if (PS >= 110 && PS <= 285 && RS === 245) {
      return "BURNER LIGHT RETRY";
    } else if (PS === 320 && IS === 80) {
      return "LOAD(G/I)";
    } else if (PS === 320 && IS === 400) {
      // update SOFC 240417 by sumin, IS === 50 -> 400
      return "LOAD(G/C)";
    }
  };

  const prestartClick = (event) => {
    history.push("/PreStartChecks_MAIN");
  };

  // update SOFC 240102, datalayer ready 값 표시 기능 추가
  // ! -> 호출하는 쪽에 null조건 추가 여부 검토 필요함
  const displayDataLayerReady = (obj) => {
    let keyArr = Object.keys(obj);
    let valueArr = Object.values(obj);
    valueArr = valueArr.map((c) =>
      c === 0 ? (c = "Disconnect") : (c = "Connected"),
    );
    console.log("data layer", obj);
    return keyArr.map((c, i) => {
      return (
        <>
          <Grid.Column width={5}>{keyArr[i]}</Grid.Column>
          <Grid.Column
            width={3}
            style={{ color: valueArr[i] === "Connected" ? "yellow" : "" }}
          >
            {valueArr[i]}
          </Grid.Column>
        </>
      );
    });
  };

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  // [UPDATE] PP Operation event log, 250703
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: "1 1 auto",
        width:
          PState <= 101 || PState === 600 || PState === 100 ? "85%" : "90%",
      }}
    >
      {/*width: (PState <= 101 || PState === 600 || PState === 100 || N205Hung === 1 ) ? '85%' : '90%' }}>*/}
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}> POWERPLANT OPERATIONS : MAIN </h1>
      <Grid columns="equal">
        {/* <Grid.Column width={(PState <= 101 || PState === 600 ||  (PState === 100  && PPStart === 1)) ? '10' : null} style = {{marginRight: '50px'}}> */}
        <Grid.Column width="10" style={{ marginRight: "10px" }}>
          {" "}
          {/** [UPDATE] PP Operation event log, 250703 */}
          <Grid.Row>
            <h3>POWER PLANT STATUS</h3>
            <Grid style={styles.grid} inverted celled columns="equal">
              <Grid.Row>
                <Grid.Column style={{ color: "yellow" }}>
                  {PPStatus(
                    PState,
                    IState,
                    OperIn_Idle,
                    OperIn_GrInd,
                    OperIn_GrConn,
                  )}
                </Grid.Column>
                <Grid.Column>
                  {/*{ExternalPower === 1 ?*/}
                  {/*    <p style={{color: 'yellow'}}> EXTERNAL-HARDWARE CONTROL</p>*/}
                  {/*    :*/}
                  {/*    <p style={{color: 'red'}}> LOCAL-OPERATOR CONTROL</p>*/}
                  {/*}*/}
                  <p style={{ color: "red" }}> LOCAL-OPERATOR CONTROL</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <h3> MAJOR DATA </h3>
            <Grid style={styles.grid} inverted celled columns="8">
              <Grid.Row>{MDColumn}</Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            {
              // PSM5PPStart === 1 ?
              PPStart === 1 ? ( //기존 코드
                // (PSM1PPStart === 1 && PSM2PPStart === 1 && PSM3PPStart === 1 && PSM4PPStart === 1 && PSM5PPStart === 1) ?
                overrideVisible.visible ? (
                  <h1 style={{ color: "yellow" }}>
                    POWER PLANT STARTING UP....
                  </h1>
                ) : (
                  <h1 style={{ color: "green" }}>
                    POWER PLANT STARTING UP....
                  </h1>
                )
              ) : (
                ""
              )
            }
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            <Grid columns="equal">
              <Grid.Column width={5}>
                <Segment inverted color="black">
                  {/*<Button.Group >*/}
                  {(electronApp ||
                    isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                    <Segment.Group horizontal>
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        {
                          // update SOFC 240223, add PSM1State to PSM5State condition
                          // PSM5PState === 110 ?
                          PState === 110 ? (
                            // (PSM1PState === 110 && PSM2PState === 110 && PSM3PState === 110 && PSM4PState === 110 && PSM5PState === 110) ?
                            <></>
                          ) : PState <= 101 || PState === 600 ? (
                            // (PSM5PState <= 101 || PSM5PState === 600) ? // test
                            // ((PSM1PState <= 101 || PSM1PState === 600) && (PSM2PState <= 101 || PSM2PState === 600) &&
                            //    (PSM3PState <= 101 || PSM3PState === 600) && (PSM4PState <= 101 || PSM4PState === 600) && (PSM5PState <= 101 || PSM5PState === 600)) ?
                            <PPOperationMacro
                              option={1}
                              data={data}
                              title={"PPLT Start"}
                              channel={"Start PP"}
                              description={
                                "Verify N2 Pressure and Verify that the Back-up Shutdown Controller" +
                                "Circuit Breaker is ON"
                              }
                              isOperationModeCopied={isOperationModeCopied}
                              setIsOperationModeCopied={
                                setIsOperationModeCopied
                              }
                              parentcallback={parentcallback}
                            />
                          ) : // PSM5PState === 500 ?
                          PState === 500 ? (
                            // (PSM1PState === 500 && PSM2PState === 500 && PSM3PState === 500 && PSM4PState === 500 && PSM5PState === 500) ?
                            <ConfirmMacro option={2} channel={"Start PP"} />
                          ) : (
                            <PPOperationMacro
                              option={2}
                              title={"PPLT Start"}
                              channel={"Start PP"}
                              description={
                                "Cannot start or re-start powerplant from this P state"
                              }
                            />
                          )
                        }
                      </Segment>
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        {
                          // PSM5PState === 500 ?
                          (PState === 450 || PState === 500) && PPSD === 1 ? ( // 기존코드
                            // ((PSM1PPStart === 500 && PSM1PPSD === 1) && (PSM2PPStart === 500 && PSM2PPSD === 1) && (PSM3PPStart === 500 && PSM3PPSD === 1) && (PSM4PPStart === 500 && PSM4PPSD === 1) && (PSM5PPStart === 500 && PSM5PPSD === 1) )?
                            <ConfirmMacro
                              option={2}
                              channel={"Abort Plant Shutdown"}
                            />
                          ) : (
                            <ConfirmMacro
                              option={2}
                              channel={"Plant Shutdown"}
                            />
                          )
                        }
                      </Segment>
                    </Segment.Group>
                  )}
                  {(electronApp ||
                    isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                    <Segment.Group horizontal>
                      <Segment
                        inverted
                        color="black"
                        style={{ textAlign: "center" }}
                      >
                        <ConfirmMacro option={2} channel={"Power Reset"} />
                      </Segment>
                      {/* <Segment inverted color='black' style={{textAlign: 'center'}}>
                                            <ConfirmMacro
                                                option ={2}
                                                channel ={'Burner Relight'}
                                            />
                                        </Segment> */}
                      {/* * //update 241220, S300 Add button ESD Reset
                                        <Segment inverted color='black' style={{textAlign: 'center'}}>
                                            <ConfirmMacro
                                                option ={2}
                                                channel ={'PSMTS ESD RESET'}
                                            />
                                        </Segment> */}
                    </Segment.Group>
                  )}
                  {/* <Segment.Group horizontal>
                                        <Segment inverted color='black' style={{textAlign: 'center'}}>
                                            <ConfirmMacro
                                                option ={2}
                                                type='watchdog'
                                                channel ={'Watchdog Reset'}
                                            />
                                        </Segment>
                                    </Segment.Group> */}
                </Segment>
              </Grid.Column>
              <Grid.Column width={11}>
                <Segment inverted color="black">
                  <Grid inverted celled columns="7">
                    <Grid.Row stretched>
                      <Grid.Column width={5}>
                        <h3 style={{ marginRight: "10px" }}> S/D TYPE </h3>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      {/*<h1 style ={{marginRight: '10px'}}> S/D TYPE </h1>*/}
                      {SDColumn}
                      {PState === 500
                        ? //PSM1PState === 500 && PSM2PState === 500 && PSM3PState === 500 && PSM4PState === 500 && PSM5PState === 500 ?
                          (electronApp ||
                            isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                            <PPOperationMacro
                              title={"Clear SD"}
                              channel={"Clear SD OK Button - Clear XSD"}
                              description={"Clear XSD while in P160"}
                            />
                          )
                        : (electronApp ||
                            isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                            <PPOperationMacro
                              title={"Clear SD"}
                              channel={
                                "Clear SD OK Button - Clear Latched Shutdowns"
                              }
                              description={"Clear latched shutdowns"}
                            />
                          )}
                    </Grid.Row>
                  </Grid>
                  <Grid inverted celled columns="3">
                    <Grid.Row>
                      {/*<h1 style ={{marginRight: '10px'}}> S/D TYPE </h1>*/}
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        <h3 style={{ paddingTop: "5px" }}>TOTAL ALARMS </h3>
                      </Grid.Column>
                      <Grid.Column width={3} style={{ textAlign: "center" }}>
                        <h3 style={{ paddingTop: "5px" }}>{data[29145]}</h3>{" "}
                        {/* Insert Total Alarm Tag ID */}
                      </Grid.Column>
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        {(electronApp ||
                          isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                          <ConfirmMacro option={2} channel={"Clear Alarms"} />
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            <Grid
              columns="equal"
              style={{ marginTop: "0px", paddingTop: "0px" }}
            >
              <Grid.Row>
                <Grid.Column width={6}>
                  <Grid inverted celled>
                    <Grid.Row>
                      <Grid.Column width={10} style={{ textAlign: "center" }}>
                        <ActiveEvents currentPLC={currentPLC} />
                      </Grid.Column>
                      <Grid.Column width={6} style={{ textAlign: "center" }}>
                        <EventLog
                          totalAlarms={data[29145]}
                          currentPLC={currentPLC}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                  {/** // update SOFC : dataLayer Connection 표시 추가
                   *      240403 by sumin, sent currentPLC data to EventLog to display each event
                   *
                   */}
                </Grid.Column>
                {(electronApp ||
                  isAuthorized(user.hmi_role, OPERATIONS_WRITE)) && (
                  <Grid.Column width={8} style={{ marginLeft: "14px" }}>
                    <Grid inverted celled>
                      <Grid.Row>
                        <Grid.Column width={6} style={{ textAlign: "center" }}>
                          <OperationMode
                            option={1}
                            data={data}
                            channel={"Operation Mode OK Button"}
                            tagid={5555}
                            isOperationModeCopied={isOperationModeCopied}
                            setIsOperationModeCopied={setIsOperationModeCopied}
                            parentcallback={parentcallback}
                          />
                        </Grid.Column>
                        <Grid.Column width={5} style={{ textAlign: "center" }}>
                          <KWDispatch
                            data={data}
                            channel={"KW Dispatch OK Button"}
                          />
                        </Grid.Column>
                        <Grid.Column width={5} style={{ textAlign: "center" }}>
                          <OperationMode
                            option={2}
                            data={data}
                            tagid={29132} // why istate assignment here? DP
                            isOperationModeCopied={isOperationModeCopied}
                            setIsOperationModeCopied={setIsOperationModeCopied}
                            parentcallback={parentcallback}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row style={{ marginTop: "10px" }}>
            <Grid
              columns="equal"
              style={{ marginTop: "0px", paddingTop: "0px" }}
            >
              <Grid.Row>
                <Grid.Column width={11}>
                  <Grid.Row>
                    <h3>DATA LAYER READY</h3>
                    <Grid style={styles.grid} inverted celled columns={4}>
                      <Grid.Row>
                        {typeof eachDataLayerReady !== "undefined"
                          ? displayDataLayerReady(eachDataLayerReady)
                          : ""}
                      </Grid.Row>
                    </Grid>
                  </Grid.Row>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
        </Grid.Column>

        {PState <= 101 ||
        PState === 600 ||
        (PState === 100 && PPStart === 1) ? (
          <Grid.Column>
            <Grid.Row>
              {PState <= 101 || PState === 600 ? (
                <Button
                  color="blue"
                  content="PRE-START IO CHECKS"
                  onClick={(event, value) => prestartClick(event)}
                />
              ) : (
                ""
              )}
            </Grid.Row>
            {/* <Grid.Row>
                        <h1 style = {{visibility: N205Hung === 1 ?  'visible' : 'hidden', color: 'red'}}> N205 HUNGSTATE - FOLLOW FCSB87167</h1>
                    </Grid.Row>
                    <Grid.Row>
                        <h1 style = {{visibility: ((HTR302SDLatch === 1) && (LPGSelect === 1 ||LPGSelect === 2)) ?  'visible' : 'hidden', color: 'red'}}>
                            HTR302 SP lowered to 350 C. HTR302_SD_Timer reset required before PPLT startup </h1>
                    </Grid.Row> */}
            <Grid.Row
              style={{
                height: 40,
                width: "95%",
                borderColor: "red",
                borderWidth: 1,
              }}
            >
              {PState === 100 && PPStart === 1 ? (
                <>
                  {overrideVisible.visible ? (
                    <h3 style={{ color: "yellow", textAlign: "center" }}>
                      P100 UNSATISFIED INTERLOCKS
                    </h3>
                  ) : (
                    <h3 style={{ color: "green", textAlign: "center" }}>
                      P100 UNSATISFIED INTERLOCKS
                    </h3>
                  )}
                  <p style={{ textAlign: "center" }}>
                    {" "}
                    If Empty all sensor based interlocks are satisfied
                  </p>
                  {ILColumn}
                </>
              ) : (
                <></>
              )}
            </Grid.Row>
            <Grid.Row>
              {/** // [UPDATE] PP Operation event log, 250703 */}
              <ActiveEventsTable
                currentPLC={currentPLC}
                data={data}
                tableData={tableData}
                setTableData={setTableData}
                fetchEvents={fetchEvents}
              />
            </Grid.Row>
          </Grid.Column>
        ) : (
          <Grid.Column>
            <Grid.Row>
              {/** // [UPDATE] PP Operation event log, 250703 */}
              <ActiveEventsTable
                currentPLC={currentPLC}
                data={data}
                tableData={tableData}
                setTableData={setTableData}
                fetchEvents={fetchEvents}
              />
            </Grid.Row>
          </Grid.Column>
        )}
      </Grid>
      <div>
        <Footer tags={FooterTags} data={data} option={"MAIN"} />
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "5px",
    textAlign: "center",
  },
  footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
  },
  grid: {
    marginTop: "10px",
  },
  left: {
    marginLeft: "20px",
  },
  right: {
    marginRight: "20px",
  },
  name: {
    whiteSpace: "pre-wrap",
  },
  Splname: {
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    showSidebar: () => dispatch(showSidebarMenu()),
    setHasHeaderReceived: (hasHeaderReceived) =>
      dispatch(setHasHeaderReceived(hasHeaderReceived)),
  };
};

const mapStateToProps = (state) => {
  return {
    sidebarVisible: state.nav.sidebarMenuVisible,
    hasHeaderReceived: state.header.hasHeaderReceived,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PPOperations_MAIN);
